module.exports = __webpack_public_path__ + "img/image-order-status-15.8e6cc594.png";